<template>
  <div class="reverseInvoiceList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="invoiceApplication"
    >
      <template slot="adSearch">
        <vm-search label="状态">
          <el-select v-model="filter.status" clearable>
            <el-option label="全部" :value="-1"/>
            <el-option label="草稿" :value="0"/>
            <el-option label="已提交" :value="1"/>
            <el-option label="已处理" :value="2"/>
          </el-select>
        </vm-search>
        <vm-search label="申请日期">
          <el-date-picker
              v-model="createTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="createTimeChange"/>
        </vm-search>
        <vm-search label="提交日期">
          <el-date-picker
              v-model="submitTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="submitTimeChange"/>
        </vm-search>
        <vm-search label="通过日期">
          <el-date-picker
              v-model="passTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="passTimeChange"/>
        </vm-search>
        <vm-search label="申请编号">
          <el-input v-model="filter.invoiceApplicationNo" clearable/>
        </vm-search>
        <vm-search label="发货单号">
          <el-input v-model="filter.invoiceNo" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model="filter.factoryNo" clearable/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model="filter.customerName" clearable/>
        </vm-search>
      </template>
      <el-table-column align="center" prop="invoiceApplicationNo" label="申请编号" width="150">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0; cursor: pointer"
              @click="goto(scope.row)">{{scope.row.invoiceApplicationNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="customerName" label="客户名称"/>
      <el-table-column align="center" prop="createTime" label="申请日期" width="150"/>
      <el-table-column align="center" prop="submitTime" label="提交日期" width="150"/>
      <el-table-column align="center" prop="passTime" label="通过日期" width="150"/>
      <el-table-column align="center" prop="status" label="状态" width="85">
        <template slot-scope="scope">
          <span v-if="scope.row.status ===0">草稿</span>
          <span v-if="scope.row.status ===1">已提交</span>
          <span v-if="scope.row.status ===2">已处理</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="creatorName" label="创建人" width="150"/>
      <el-table-column label="操作" width="200px" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
              v-if="!passAuth"
              type="primary"
              :disabled="scope.row.status!==0"
              @click="updateStatus(scope.row,1)">
            提交
          </el-button>
          <el-button v-if="passAuth" type="success" :disabled="scope.row.status!==1" @click="updateStatus(scope.row,2)">
            通过
          </el-button>
          <el-button type="danger" @click="deleteOne(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "InvoiceApplicationList",
    components: {VmTable, VmSearch},
    data() {
      return {
        selection: [],
        passAuth: this.$auth(435),
        createTime: "",
        submitTime: "",
        passTime: "",
        filter: {
          status: -1,
          factoryNo: "",
          invoiceNo: "",
          invoiceApplicationNo: "",
          customerName: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitTimeBegin: "",
          submitTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      goto(row) {
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: row.pkid,
            $tabName: row.invoiceApplicationNo,
          },
        });
      },

      deleteOne(row) {
        this.$http.delete("basic", "invoiceApplication", row.pkid)
          .then(() => {
            this.$message.success("删除成功");
            this.getList(1);
          }).catch(() => {
            this.$message.error("删除失败");
          });
      },

      updateStatus(row, status) {
        this.$http.get("basic", `invoiceApplication/updateStatus/${row.pkid}/${status}`)
          .then(() => {
            this.$message.success("更新成功");
            this.getList(1);
          }).catch(() => {
            this.$message.error("更新失败");
          });
      },

      createTimeChange(date) {
        if (date !== null) {
          this.filter.createTimeBegin = date[0];
          this.filter.createTimeEnd = date[1];
        } else {
          this.filter.createTimeBegin = "";
          this.filter.createTimeEnd = "";
        }
      },

      submitTimeChange(date){
        if (date !== null) {
          this.filter.submitTimeBegin = date[0];
          this.filter.submitTimeEnd = date[1];
        } else {
          this.filter.submitTimeBegin = "";
          this.filter.submitTimeEnd = "";
        }
      },

      passTimeChange(date){
        if (date !== null) {
          this.filter.passTimeBegin = date[0];
          this.filter.passTimeEnd = date[1];
        } else {
          this.filter.passTimeBegin = "";
          this.filter.passTimeEnd = "";
        }
      },
    },
  };
</script>
<style lang="scss">
</style>
